import React, { useEffect, useState } from "react";

const useCheckShadow = ({ ref, scrollBasedOn }: { ref: any, scrollBasedOn?: any[] }) => {
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);

  // Handle shadow visibility based on scroll position
  useEffect(() => {
    const container = ref?.current;
    if (!container) return;

    const checkShadows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      setShowLeftShadow(scrollLeft > 0);
      setShowRightShadow(scrollLeft + clientWidth < scrollWidth - 1);
    };

    checkShadows();

    container.addEventListener("scroll", checkShadows);

    const observer = new ResizeObserver(checkShadows);
    observer.observe(container);

    return () => {
      container.removeEventListener("scroll", checkShadows);
      observer.disconnect();
    };
  }, scrollBasedOn);

  // Auto-scroll to right when a new chip is added
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({
        left: ref.current.scrollWidth,
        behavior: "smooth",
      });
    }
  }, scrollBasedOn);

  return { showLeftShadow, showRightShadow };
};

export default useCheckShadow;
